/* Skinsy all-reviews page — the filter chips, and nothing else.

   Client-side because every review is already in the DOM: the page renders the
   whole set, so narrowing it is a display concern and a round trip to the
   server would be a round trip to fetch markup the browser is holding.

   The chips are markup-hidden until this runs. With JavaScript off they never
   appear, and the reader gets the complete list — which is the correct
   fallback for a filter, and the same rule the collection page follows. */
(function () {
  'use strict';

  document.querySelectorAll('[data-skinsy-reviews]').forEach(function (root) {
    var bar = root.querySelector('[data-filters]');
    var grid = root.querySelector('[data-grid]');
    if (!bar || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-review]'));
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-filter]'));
    var empty = root.querySelector('[data-empty]');
    if (!cards.length || !chips.length) return;

    function apply(value) {
      var shown = 0;

      cards.forEach(function (card) {
        var keep =
          value === 'all' ? true :
          value === 'photo' ? card.dataset.photo === 'true' :
          card.dataset.rating === value;

        card.hidden = !keep;
        if (keep) shown += 1;
      });

      chips.forEach(function (chip) {
        var on = chip.dataset.filter === value;
        chip.classList.toggle('is-on', on);
        /* The chips are a single-choice set, so the pressed one is state, not a
           label — without this a screen reader hears five identical buttons and
           no way to tell which list it is looking at. */
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      /* A filter that can empty the grid has to say so. Every chip is built
         from a non-zero tally, so this should be unreachable — but the tally is
         computed at render time and the chips are clicked later, and "should be
         unreachable" is not a reason to show a blank page if it is. */
      if (empty) empty.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.classList.contains('is-on') ? 'true' : 'false');
      chip.addEventListener('click', function () {
        apply(chip.dataset.filter);
      });
    });

    bar.hidden = false;
  });
})();
